import { Link } from "react-router-dom";

export function NotFoundPage(): JSX.Element {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-3xl font-semibold text-slate-800">页面未找到</h1>
      <p className="max-w-md text-sm text-slate-500">页面不存在或已迁移，请返回首页。</p>
      <Link
        to="/"
        className="rounded-md bg-brand px-4 py-2 text-sm font-semibold text-white shadow hover:bg-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
      >
        返回首页
      </Link>
    </div>
  );
}
